var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('i',{staticClass:"left iconfont icon-youjiantou"}),_vm._v(" "),_vm._l((new Array(Math.ceil(_vm.total / _vm.size))),function(i,k){return _c('div',{key:k,staticClass:"item",class:{active: _vm.curi===k}},[_vm._v(_vm._s(k+1)+"\n  ")])}),_vm._v(" "),_c('i',{staticClass:"right iconfont icon-youjiantou"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50ae59e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page.vue
// module id = null
// module chunks = 